<div class="caller-view-container" onsip-grid-placement-shelf>
  <div class="first-column">
    <section class="property">
      <div class="mat-body-1 property-header">Announce hold time</div>
      <div>
        {{ queue.announceHoldTime ? "Every " + queue.announceFrequency + " seconds" : "Never" }}
      </div>
    </section>
    <section class="property">
      <div class="mat-body-1 property-header">While on hold caller hears</div>
      <div>{{ queue.musicSourceName ? queue.musicSourceName : "Ringing only" }}</div>
    </section>
    <section class="property">
      <div class="mat-body-1 property-header">Caller timeout</div>
      <div>{{ queue.callerTimeout + " seconds" }}</div>
    </section>
  </div>
  <div class="second-column">
    <section class="property">
      <div class="mat-body-1 property-header">Failover address</div>
      <div>{{ fullName$ | async }}</div>
    </section>
    <section class="property">
      <div class="mat-body-1 property-header">Escape voicemail box</div>
      <div>{{ queue.escapeAddress ? queue.escapeAddress : "None" }}</div>
    </section>
  </div>
</div>
<div class="page-view-controls">
  <button mat-flat-button class="toggle-button" color="primary" (click)="togglePanel()">
    {{ "ONSIP_I18N.EDIT_INFO" | translate }}
  </button>
</div>
